import { Drawer } from '@uy3/web-components';
import { ToastType } from 'contexts/apiRequestContext';
import React from 'react'
import { ShareRecordsContainer } from './ShareRecordContainer';
import { ShareResourceDisplayType } from 'services/share/types/share';

type ShareRecordDrawerProps = {
    setToast: React.Dispatch<React.SetStateAction<ToastType>>;
    open: boolean; 
    onClose: () => void;
    resourceId: string;
    resourceDisplay: ShareResourceDisplayType
}

export const ShareRecordDrawer = ({ setToast, open, onClose, resourceId, resourceDisplay }: ShareRecordDrawerProps) => {
    return (
        <Drawer
            anchor="right"
            open={open}
            title="Compartilhar registro"
            onClose={onClose}
            children={
                <ShareRecordsContainer
                    {...{
                        onClose,
                        resourceId,
                        setToast,
                        resourceDisplay
                    }}
                />
            }
        />
    )
}
